import { JAB_CHAT_ORG } from "./jobChatGuard";

export const JAB_CHAT_DEBUG_IDENTITY = "7ebe5d45-cd7d-4a69-98e9-15a13863258a";

// Presentation routing only. The server verifies the signed Cognito subject,
// current exact SQL membership, job ownership and its separate activation flag.
export function usesJobChatDebugMode(orgId, identityId) {
  return orgId === JAB_CHAT_ORG && identityId === JAB_CHAT_DEBUG_IDENTITY;
}

const isMessage = m => m && typeof m.id === "string" && typeof m.text === "string"
  && m.sender && typeof m.sender.id === "string" && typeof m.sender.name === "string"
  && typeof m.createdAt === "string" && typeof m.parentId === "string" && Number.isSafeInteger(m.replyCount)
  && (m.threadToken == null || (typeof m.threadToken === "string" && m.threadToken.length <= 8192))
  && (m.mentionedUsers === undefined || (Array.isArray(m.mentionedUsers) && m.mentionedUsers.length <= 50
    && m.mentionedUsers.every(u => u && typeof u.id === "string" && typeof u.name === "string")))
  && Array.isArray(m.attachments) && m.attachments.length <= 20
  && m.attachments.every(a => a && typeof a.url === "string" && typeof a.title === "string"
    && ["type", "asset_url", "image_url", "thumb_url", "mime_type", "fallback"].every(k => a[k] === undefined || typeof a[k] === "string")
    && (a.file_size === undefined || (Number.isSafeInteger(a.file_size) && a.file_size >= 0)));

export function isDebugResponseFor(response, {orgId, instanceId, scope, view, thread, parentId}) {
  const cid = `team:instance-${instanceId}${scope === "internal" ? "-internal" : ""}`;
  return response && response.readOnly === true && response.orgId === orgId
    && response.instanceId === instanceId && response.scope === scope && response.view === view && response.cid === cid
    && Array.isArray(response.messages) && Array.isArray(response.members)
    && response.messages.length <= 50 && response.members.length <= 50
    && Number.isSafeInteger(response.page) && response.page > 0
    && (typeof response.jobId === "string" || typeof response.jobId === "number")
    && (response.cursor === null || (typeof response.cursor === "string" && response.cursor.length <= 8192))
    && (response.historyNotice === null || typeof response.historyNotice === "string")
    && response.members.every(m => m && typeof m.id === "string" && typeof m.name === "string" && typeof m.channelRole === "string")
    && response.messages.every(isMessage)
    && (view !== "thread" || (response.thread === thread && response.parentId === parentId
      && isMessage(response.parent) && response.parent.id === parentId && !response.parent.deleted
      && response.messages.every(m => m.parentId === parentId)));
}
